import { render, staticRenderFns } from "./DesmatamentoVegaComSoja2324VegaParaguai.vue?vue&type=template&id=489fd284&lang=pug"
import script from "./DesmatamentoVegaComSoja2324VegaParaguai.vue?vue&type=script&lang=js"
export * from "./DesmatamentoVegaComSoja2324VegaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports